import React, { useEffect, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import api from '@/api/services/achievements';
import { Typography } from '@/components/Atoms';
import CounterSlow from '@/components/Molecules/CounterSlow';
import { numberSeparator } from '@/utils/numberSeparator';

export interface TotalSoldierProps {}

const TotalSoldier: React.FunctionComponent<TotalSoldierProps> = () => {
  const { t } = useTranslate('commandCenter');
  const [ArmyData, setArmyData] = useState({
    all_army_count: 0,
    all_user_accepted_agreement: 0,
  });
  const fetchArmyData = () => {
    api.getArmyCount().then((res) => {
      if (ArmyData.all_user_accepted_agreement !== res.data.all_user_accepted_agreement) {
        setArmyData(res.data);
      }
    });
  };
  useEffect(() => {
    fetchArmyData(); // Initial fetch
    const intervalId = setInterval(fetchArmyData, 5000); // Set interval for every minute (60000ms)
    // Cleanup function to clear the interval
    return () => clearInterval(intervalId);
  }, []);
  return (
    <div className='col-span-12  xl:col-span-2 bg-[#3C3B3B] bg-opacity-40 rounded-[10px] row-span-2  md:mt-0 mb-1 px-2 py-1 justify-center flex flex-row gap-x-16 xl:flex-col xl:max-h-[160px] overflow-hidden'>
      <div className='xl:hidden w-full h-[1px] bg-[#4F4F4F] flex items-center my-auto'></div>
      <div className='flex flex-col justify-center items-center'>
        <Typography size='s12ToS12' className='text-nowrap'>
          {t('CENTER_SECTION.pledgeSection.loyalSoldier')}
        </Typography>
        <Typography isBold size='s20ToS14' className='bg-gradient-to-b bg-clip-text text-transparent from-[#FFD600] to-[#FF9900]'>
          {numberSeparator(ArmyData.all_army_count)}
        </Typography>
      </div>
      <div className='flex flex-col justify-center items-center'>
        <Typography size='s12ToS12' className='text-nowrap'>
          {t('CENTER_SECTION.pledgeSection.soldier')}
        </Typography>
        <Typography isBold size='s20ToS14' className='text-[#00FFE0] items-center flex justify-center'>
          <CounterSlow end={numberSeparator(ArmyData.all_user_accepted_agreement).toString()} />
        </Typography>
      </div>
      <div className='xl:hidden w-full h-[1px] bg-[#4F4F4F]  flex items-center my-auto'></div>
    </div>
  );
};

export default TotalSoldier;
